<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 17 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g id="_2">
    </g>
    <g transform="matrix(1.57377,0,0,1.58204,0.63115,0.0898)">
        <path d="M3,1.5L10,1.5L10,0.5L3,0.5L3,1.5ZM10,5.5L3,5.5L3,4.5L10,4.5L10,5.5ZM3,9.5L10,9.5L10,8.5L3,8.5L3,9.5Z"
              style="fill:currentColor;"/>
      <g transform="matrix(1.40143,0,0,0.972954,-1.60988,-0.360995)">
            <g transform="matrix(3.37648,0,0,3.37648,2.83262,2.78036)">
            </g>
        <text x="0.955px" y="2.78px"
              style="font-family:'Arial-BoldMT', 'Arial', sans-serif;font-weight:700;font-size:3.376px;fill:currentColor;">1</text>
        </g>
      <g transform="matrix(1.17695,0,0,0.895954,-1.11748,3.63846)">
            <g transform="matrix(3.37648,0,0,3.37648,2.83262,2.78036)">
            </g>
        <text x="0.955px" y="2.78px"
              style="font-family:'Arial-BoldMT', 'Arial', sans-serif;font-weight:700;font-size:3.376px;fill:currentColor;">2</text>
        </g>
      <g transform="matrix(1.16134,0,0,0.850577,-1.11121,7.56546)">
            <g transform="matrix(3.37648,0,0,3.37648,2.83262,2.78036)">
            </g>
        <text x="0.955px" y="2.78px"
              style="font-family:'Arial-BoldMT', 'Arial', sans-serif;font-weight:700;font-size:3.376px;fill:currentColor;">3</text>
        </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'OrderIcon'
}
</script>
